// Shared RecoveryAI numeric constants. Dependency-free leaf module (mirrors the
// Settings/tabKeys.ts precedent) so both the wizard's DailyCapCard and the
// Settings DailyBudgetPane import from a neutral scene root instead of reaching
// across the Wizard ↔ Settings subtrees.

// Reasonable upper bound for the daily budget — $100k/day per merchant is far
// above any expected pilot configuration. Surfaced as the field `max` by both
// the wizard DailyCapCard and the Settings DailyBudgetPane; the pane also clamps
// the persisted cents to [0, MAX_DAILY_BUDGET_DOLLARS * 100] before the PUT.
export const MAX_DAILY_BUDGET_DOLLARS = 100_000

// int32-max — the backend's Recovery::Budget::LIMITLESS_CENTS "unlimited budget"
// sentinel stored in default_daily_budget_cents. Only CS/DB can set it; the FE
// never writes it and renders a read-only "Unlimited" state on read. NOT the
// MAX_POINTS ceiling in CaseDetail/GrantRewardModal — same integer, opposite
// meaning (a points cap that disables Confirm above it).
export const RECOVERY_LIMITLESS_BUDGET_CENTS = 2_147_483_647
